import { useState, useEffect, useMemo, useRef } from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'

import { ActiveFilterViewer, Filters } from '@rankmi/rankmi-table'
import TableUsers from 'components/ui/TableUsers'
import { useUsersColumns } from 'components/configuration/components/lms-profiles/common/hooks'
import { UnArray } from 'helpers/types.helper'
import useUserColumnsFilters from 'hooks/users/useUserColumnsFilters'
import { TableProps } from './types'
import { Actions } from './styled'

const UsersTable = ({
  onAllRowKeys,
  data: { loading, list, total },
  onRowSelected,
  onRemove,
  selected,
  paginationConfig: {
    setSort,
    page,
    setPage,
    perPage,
    setPerPage,
    filterData,
    onChangeFilterData,
    search,
    onSearch,
  },
  actions,
}: TableProps) => {
  const { filtersColumns } = useUserColumnsFilters()

  const [showFiltersModal, setShowFiltersModal] = useState(false)

  const dataSource = useMemo(
    () =>
      list.map((user) => ({
        key: user.id,
        ...user,
      })),
    [list]
  )

  const baseColumns = useUsersColumns()
  const columns = useMemo(
    () => [
      ...baseColumns,
      {
        title: '',
        key: 'action',
        width: 50,
        hideable: false,
        render: (_, participant: UnArray<typeof dataSource>) => (
          <Actions>
            <Button onClick={() => onRemove(participant)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Actions>
        ),
      },
    ],
    [baseColumns, onRemove]
  )

  const handleAllSelectedRef = useRef(onAllRowKeys)

  useEffect(() => {
    handleAllSelectedRef.current = onAllRowKeys
  }, [onAllRowKeys])

  return (
    <>
      <div className="row">
        <div className="col">
          <Filters
            columns={filtersColumns}
            onChange={(value) => {
              onChangeFilterData(value)
            }}
            open={showFiltersModal}
            onVisibilityChange={(state: boolean) => {
              setShowFiltersModal(state)
            }}
            selectedFilters={filterData}
          />
        </div>
        <div className="col-auto">{actions}</div>
      </div>
      {filterData && (
        <div className="mt-4">
          <ActiveFilterViewer
            activeFilters={filterData}
            onChange={(data) => onChangeFilterData(data)}
            openFilters={(state: boolean) => setShowFiltersModal(state)}
            columns={filtersColumns}
          />
        </div>
      )}
      <div>
        <TableUsers
          changeColumnsVisibility
          responsive
          data={dataSource}
          search={search}
          currentPage={page}
          initialRowsPerPage={perPage}
          delaySearch
          onSearch={onSearch}
          total={total}
          columnHeaders={columns}
          onSortChange={(sortData) => setSort(sortData)}
          onRowSelected={onRowSelected}
          selectedRows={selected}
          onPaginationChange={(currentPage: number) => setPage(currentPage)}
          simpleSelectAll={true}
          onRowsPerPageChange={(itemsPerPage: number) =>
            setPerPage(itemsPerPage)
          }
          onAllRowKeys={
            onAllRowKeys
              ? () => {
                  // Rankmi-table has a bug, use onAllRowKeys how reference
                  handleAllSelectedRef.current?.()
                }
              : undefined
          }
          fastActions={[]}
          loading={loading}
        />
      </div>
    </>
  )
}

export default UsersTable
